<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

import TicketsData from "./tickets-data";

import {
  layoutComputed,
  authComputed,
  ticketsMethods,
  ticketsComputed,
  provincesMethods,
  provincesComputed,
  regionsMethods,
  regionsComputed,
} from "@/state/helpers";
/**
 * Tickets component
 */
export default {
  page: {
    title: "Tickets",
    meta: [{ name: "Tickets" }],
  },
  components: {
    Layout,
    PageHeader,
    TicketsData,
  },
  mounted() {
    this.retrieveTickets({})
    .then(async ()=>{
      await this.retrieveTicketsCauses();
      await this.retrieveRegions();
      await this.retrieveProvinces();
    });
    
  },
  data() {
    return {
      title: "titles.tickets.text",

      currentPage: 1,
      perPage: 10,

      busy: false,

      xlsxFile: null,

      loaderDashboard: false,

      ticketsData: [],

      provincesData: [],
      regionsFilterData: [{ value: null, text: "--All--" }],
      provincesFilterData: [{ value: null, text: "--All--" }],
      ticketsFilter: {
        regions: null,
        provinces: null,
      },
      regions: [null],
      provinces: [null],

      ticketCausesData: [],
    };
  },
  computed: {
    ...layoutComputed,
    ...authComputed,
    ...ticketsComputed,
    ...provincesComputed,
    ...regionsComputed,

    items(){
      return [
        {
          text: "Nextrack",
        },
        {
          text: this.$t("titles.tickets.text"),
          active: true,
        },
      ]
    },

    userRole(){
      return this.loggedIn.user.role
    }
  },
  methods: {
    ...ticketsMethods,
    ...provincesMethods,
    ...regionsMethods,

    retrieveTickets({
      page, 
      perPage, 
      regions,
      provinces,
    }) {
      this.busy = true;
      const params = {
        page: page ? page : this.currentPage,
        limit: perPage ? perPage : this.perPage,
        populate: 'region,province,centre,actions,causes,createdBy,closedBy,technicien', 
        sortBy: '-createdAt',
        regions: regions ? regions : this.ticketsFilter.regions,
        provinces: provinces ? provinces : this.ticketsFilter.provinces,
      }
      if(this.userRole == "TECHNICIEN")
        params.technicien = this.loggedIn.user.id;
      return this.getTicketsBy(params).then(() => {
        this.busy = false;
      });
    },
    retrieveTicketsCauses() {
      return this.getTicketCausesBy()
        .then((res) => {
          return res;
        })
        .catch((error) => {
          return error;
        });
    },
    retrieveRegions() {
      if (this.getRegions.results)
        return this.chargeRegions(this.getRegions.results);
      else
        return this.getRegionsBy({ limit: 100 }).then((regions) => {
          return regions;
        });
    },
    retrieveProvinces(regions) {
      if (this.getProvinces.results)
        return this.chargeProvinces(this.getProvinces.results, regions);
      else
        return this.getProvincesBy({ limit: 100 }).then((provinces) => {
          return provinces;
        });
    },
    chargeRegions(regions) {
      let rData = regions;
      rData.map((obj) => {
        this.regionsFilterData.push({ value: obj.id, text: obj.name });
      });
    },
    chargeProvinces(regions) {
      this.provincesFilterData = [{ value: null, text: "--All--" }];
      let pData = this.getProvinces.results;
      pData.map((obj) => {
        if (regions.includes(obj.region))
          this.provincesFilterData.push({ value: obj.id, text: obj.name });
      });
    },
    filter() {
      this.currentPage = 1;
      this.retrieveTickets({ ...this.ticketsFilter, page: 1 }).then(() => {
        this.hideFilter();
      });
    },
    clear() {
      this.ticketsFilter = {
        regions: null,
        provinces: null,
      };
      this.regions = [null];
      this.provinces = [null];
    },
    makeToast(title, msg, variant) {
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        solid: true,
      });
    },
    openFilter(){
      this.$bvModal.show("filter-modal");
    },
    hideFilter(){
      this.$bvModal.hide("filter-modal");
    },
    handlePageChange(value) {
      this.currentPage = value;
      this.retrieveTickets({});
    },
  },
  watch: {
    getTickets(newVal) {
      this.ticketsData = newVal.results;
    },
    getTicketCauses(newVal){
      this.ticketCausesData = newVal.results;
    },
    /* getProvinces(newVal) {
      this.chargeProvinces(newVal.results, this.regions);
    }, */
    getRegions(newVal) {
      this.chargeRegions(newVal.results);
    },
    regions(newVal) {
      let lenRegions = newVal.length;

      if (!newVal[lenRegions - 1] && lenRegions > 1) {
        this.regions = [null];
        this.ticketsFilter.regions = null;
      } else if (newVal[lenRegions - 1] && newVal.includes(null)) {
        var filteredRegions = this.regions.filter(function (item) {
          return item != null;
        });
        this.regions = filteredRegions;
      } else if (newVal[lenRegions - 1] && !newVal.includes(null)) {
        this.ticketsFilter.regions = newVal;
      } else if (newVal.length == 0) {
        this.regions = [null];
        this.ticketsFilter.regions = null;
      }
      this.chargeProvinces(newVal);
    },
    provinces(newVal) {
      let lenProvinces = newVal.length;

      if (!newVal[lenProvinces - 1] && lenProvinces > 1) {
        this.provinces = [null];
        this.ticketsFilter.provinces = null;
      } else if (newVal[lenProvinces - 1] && newVal.includes(null)) {
        var filteredProvinces = this.provinces.filter(function (item) {
          return item != null;
        });
        this.provinces = filteredProvinces;
      } else if (newVal[lenProvinces - 1] && !newVal.includes(null)) {
        this.ticketsFilter.provinces = newVal;
      } else if (newVal.length == 0) {
        this.provinces = [null];
        this.ticketsFilter.provinces = null;
      }
    },
  },
  beforeDestroy() {},
};
</script>

<template>
  <Layout>
    <PageHeader :title="$t(title)" :items="items" />
    <div  class="d-flex flex-row-reverse mb-2">
      <div class="text-right">
        <b-button type="button" class="mr-2" variant="light" @click="openFilter"
          ><i class="ri-filter-3-line"></i>
        </b-button>
        <b-modal 
          id="filter-modal"
          ref="filter-modal"
          hide-footer
          size="md"
          :title="this.$t('modals.filterPlanif.text')"
        >
          <div class="row">
            <div class="col-12" data-app>
              <label for="regionSh">{{ $t("modals.region.text") }}</label>
              <v-select
                id="regionSh"
                v-model="regions"
                :items="regionsFilterData"
                :menu-props="{ maxHeight: '200' }"
                item-text="text"
                item-value="value"
                multiple
              ></v-select>
            </div>
            <div class="col-12" data-app>
              <label for="provinceSh">{{ $t("modals.province.text") }}</label>
              <v-select
                id="provinceSh"
                v-model="provinces"
                :items="provincesFilterData"
                :menu-props="{ maxHeight: '200' }"
                item-text="text"
                item-value="value"
                multiple
              ></v-select>
            </div>
            <div class="col-12 text-center">
              <b-button type="button" variant="light" @click="filter"
                >{{$t("buttons.filter.text")}}
              </b-button>
            </div>
          </div>
        </b-modal>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <TicketsData v-bind:tickets="ticketsData" :ticketCauses="ticketCausesData" :busy="busy" />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="dataTables_paginate paging_simple_numbers float-right">
          <ul class="pagination pagination-rounded">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="getTickets.totalResults"
              :per-page="perPage"
              @change="handlePageChange"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </Layout>
</template>